// extracted by mini-css-extract-plugin
export default {"resetContainer":"EditImageTabContent_resetContainer__950MW"};